import type CalendarSearchStore from '../schema/CalendarSearchStore';
import { createStore } from 'satcheljs';
import '../mutators/resetSearchStoreMutator';
import '../mutators/searchSessionMutators';
import '../mutators/initSearchDatapointMutator';
import '../mutators/setAutoScrollMutator';
import '../mutators/setAccountScopeMutator';
import '../mutators/setCalendarFoldersScopeMutator';
import '../mutators/setNonSearchableCalendarsTextMutator';
import '../mutators/toggleRefinersVisibleMutator';
import '../mutators/searchRefinersMutator';

export const defaultCalendarSearchStoreData: CalendarSearchStore = {
    accountSmtpAddress: null,
    searchEndToEndDatapoints: [],
    includeAttachments: false,
    fromDate: null,
    toDate: null,
    searchNumber: 0,
    calendarFoldersScope: null,
    refinersVisible: false,
    isAutoScroll: false,
    selectedCalendarsCount: 0,
    notSupportedNotification: null,
    searchBoxWidth: null,
};

const initialStore = { ...defaultCalendarSearchStoreData };

export default createStore<CalendarSearchStore>('CalendarSearchStore', initialStore);
